export default __webpack_public_path__ + "static/media/tailwind.fc2637ed.png";